<template>
	<div class="wrapper-cell">
		<el-input
			v-model="row[column.key]"
			placeholder="请输入数字"
			oninput="value=value.replace(/[^0-9.]/g,'')"
			@blur="validateInput"
		>
      <el-button slot="append">%</el-button>
    </el-input>
        <span v-if="column.required" class="required-star">*</span>
		<div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>
	</div>
</template>

<script>
import mixin from '@/components/tableCells/mixin';
import { checkServiceFeeRate } from '@/utils/validate';

export default {
	name: 'adServiceRateInputCell',
	mixins: [mixin],
	data() {
		return {
			errorMsg: ''
		};
	},
	methods: {
		validateInput() {
			const value = this.row[this.column.key];
			if (value === '' || value === undefined) {
				this.errorMsg = '投放期服务费率不可为空';
				return;
			}
			
			const rate = parseFloat(value);
			if (isNaN(rate)) {
				this.errorMsg = '请输入有效的数字';
				return;
			}
			
			this.errorMsg = '';
			//格化为最多一位小数
			this.row[this.column.key] = rate;
		}
	}
};
</script>

<style scoped>
.wrapper-cell{
    position: relative;
    padding-bottom: 20px;
}
.required-star {
	color: #f56c6c;
    position: absolute;
    left: -12px;
    top: 6px;
}
.error-msg {
	color: #f56c6c;
	font-size: 12px;
    position: absolute;
    left: 2px;
    bottom: 0px;
}
</style>